import { Button, Flex } from '@chakra-ui/react'
import { ChevronLeft, ChevronRight } from '../icons'

interface PaginationProps {
  totalCount: number
  maxButtonCount?: number
  currentPage: number
  pageSize?: number
  setCurrentPage: (page: number) => void
}

const Page = ({ pageNumber, isCurrent, onClick }: { pageNumber: number; isCurrent: boolean, onClick: (page: number) => void }) => {
  return (
    <Button
      type="button"
      onClick={() => onClick(pageNumber)}
      variant={isCurrent ? 'solid' : 'ghost'}
      colorScheme={isCurrent ? 'primary' : 'white'}
      _hover={{ outlineColor: 'primary.500', outlineWidth: 1, outlineOffset: -1 }}
    >
      {pageNumber}
    </Button >
  )
}

// generovani pole hodnot od - do s krokem
const range = (start: number, stop: number, step: number) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + (i * step))

export const Pagination = ({ totalCount, currentPage, maxButtonCount = 5, pageSize = 10, setCurrentPage }: PaginationProps) => {

  // celkovy pocet stranek
  const totalPagesCount = Math.ceil(totalCount / pageSize)

  // pokud je stránek mene nez tlacitek, tak zmensime jejich pocet
  if (maxButtonCount > totalPagesCount) maxButtonCount = totalPagesCount

  // zjisteni na jakem cisle ma strankovani zrovna zacit a na jakem koncit
  const startPage = Math.floor(currentPage - ((maxButtonCount / 2) - 1))
  let start = startPage < 1 ? 1 : startPage
  let end = start + maxButtonCount - 1

  if (end > totalPagesCount) {
    end = totalPagesCount
    start = totalPagesCount - maxButtonCount + 1
    start = start < 1 ? 1 : start
  }

  // vygenerovani tlacitek
  const pages = range(start, end, 1)

  return (
    <Flex sx={{ w: '100%', gap: 1, justifyContent: 'center' }}>
      <Flex flex={1}>{/* TODO: editovat počet záznamů na stránku */}</Flex>

      {start > 1 && <Button variant='ghost' colorScheme='white' onClick={() => setCurrentPage(currentPage - 1)} ><ChevronLeft /></Button>}
      {pages &&
        pages.length > 1 &&
        pages.map((page) =>
          <Page key={page} pageNumber={page} isCurrent={page === currentPage} onClick={setCurrentPage} />
        )
      }
      {end < totalPagesCount && <Button variant='ghost' colorScheme='white' onClick={() => setCurrentPage(currentPage + 1)}><ChevronRight /></Button>}

      <Flex ml='auto' my={2} flex={1} justifyContent='flex-end'>celkem {totalCount} {totalCount == 1 ? 'záznam' : (totalCount < 5 && totalCount != 0 ? 'záznamy' : 'záznamů')}</Flex>
    </Flex>
  )
}
